require('../../candidates/search/jv.search.filters.directive.webpack');
require('../../candidates/search/jv.search.filter.directive.webpack');
require('../../candidates/search/jv.search.collection-list-modal.directive.webpack');
require('../../common/directives/jv.AjaxSelect');
require('../../common/directives/jv.Datepicker');
require('../../common/directives/jv.simple-select.directive');
require('../../common/jv.EmployeeSelect');
require('../../common/jv.i18n');
require('./jv.Admin.Users.MainCtrl');
require('../../common/directives/jv.AccessGroupSelect');

angular.module('jvAdmin.Users.app', [
    'ngRoute',
    'jv',
    'JV.Core.Directives',
    'jv.search.filters.directive',
    'jv.search.filter.directive',
    'jv.search.collection-list-modal.directive',
    'jv.Common.AjaxSelect',
    'jv.Common.Directives.Datepicker',
    'jv.simple-select.directive',
    'jv.Common.EmployeeSelect',
    'jv.Common.i18n',
    'jv.Admin.Users',
    'jv.Admin.Users.Roles.app',
    'jv.Common.AccessGroupSelect',
    'jv.React.Admin.Users.AccessGroups'
]).config(['$locationProvider', function($locationProvider) {
    $locationProvider.hashPrefix('');
}]);
